'use strict';

/**
 * @ngdoc service
 * @name cidadanize.factories:dataHolderFactory
 * @description
 * Holds objects for entire app
 *
 */
function dataHolderFactory($rootScope) {
	var currentLayer = '', pdfDataUri = '', sortingOptionIndex = 2, filterOptions = null, contractDetails = null, clusteredContracts = [], contracts = [], currentSiteId = 0, mapAlbumPhotos = null, albumPhotoId = '', favoriteFilters = null, favoriteFilterSelected = null, currentDetalhe = null, currentTitulo = null;
	return {
		updateLayer: function(_currentLayer) {
			currentLayer = _currentLayer;
		},
		updateContractDetails: function(_contractDetails) {
			contractDetails = _contractDetails;
		},
		updateFilterOptions: function(_filterOptions) {
			filterOptions = _filterOptions;
		},
		updateContracts: function(_contracts) {
			contracts = _contracts;
		},
		updatePdfDataUri: function(_pdfDataUri) {
			pdfDataUri = _pdfDataUri;
		},
		updateClusteredContracts: function(_clusteredContracts) {
			clusteredContracts = _clusteredContracts;
		},
		updateSortingOptionIndex: function(_sortingOptionIndex) {
			sortingOptionIndex = _sortingOptionIndex;
		},
		updateCurrentLayer: function(_currentLayer) {
					currentLayer = _currentLayer;
		},
		updateCurrentSiteId: function(_currentSiteId) {
			currentSiteId = _currentSiteId;
		},
    updateMapAlbumPhotos: function(_mapAlbumPhotos) {
      mapAlbumPhotos = _mapAlbumPhotos;
    },
    updateAlbumPhotoId: function(_albumPhotoId) {
      albumPhotoId = _albumPhotoId;
		},
		updateFavoriteFilters: function (_favoriteFilters) {
			favoriteFilters = _favoriteFilters;
		},
		updateFavoriteFilterSelected: function (_favoriteFilterSelected) {
			favoriteFilterSelected = _favoriteFilterSelected;
			$rootScope.$emit('updatedFavoriteFilterSelected', _favoriteFilterSelected);
		},
    updateDetailInfo: function(_titulo, _detalhe) {
      currentTitulo = _titulo;
      currentDetalhe = _detalhe;
    },
		getClusteredContracts: function() {
			return clusteredContracts;
		},
		getPdfDataUri: function() {
			return pdfDataUri;
		},
		getSortingOptionIndex: function() {
			return sortingOptionIndex;
		},
		getContracts: function() {
			return contracts;
		},
		getSavedLayer: function() {
			return currentLayer;
		},
		getCurrentLayer: function() {
		return currentLayer;
		},
		getSavedContractDetails: function() {
			return contractDetails;
		},
		getSavedFilterOptions: function() {
			return filterOptions;
		},
		getCurrentSiteId: function() {
			return currentSiteId;
		},
    getMapAlbumPhotos: function() {
      return mapAlbumPhotos;
    },
    getAlbumPhotoId: function() {
      return albumPhotoId;
		},
		getFavoriteFilters: function () {
			return favoriteFilters;
		},
		getFavoriteFilterSelected: function () {
			return favoriteFilterSelected;
		},
    getDetailInfo: function() {
      return {
        titulo: currentTitulo,
        detalhe: currentDetalhe
      };
    }
	};
}
dataHolderFactory.$inject = ['$rootScope']
export default dataHolderFactory



// WEBPACK FOOTER //
// ./src/app/scripts/factories/dataHolderFactory.js